/**
 * String similarity thresholds for track matching
 * Used in album upload workflow for detecting duplicate/similar songs
 */

export const SIMILARITY_THRESHOLDS = {
  /**
   * Minimum similarity score for artist name matching
   * Range: 0-1 (0 = no match, 1 = exact match)
   */
  ARTIST_MATCH: 0.7,

  /**
   * Title similarity threshold when artist also matches
   * Lower threshold since we have additional confidence from artist match
   */
  TITLE_WITH_ARTIST_MATCH: 0.7,

  /**
   * Title similarity threshold when artist doesn't match
   * Higher threshold to reduce false positives
   */
  TITLE_WITHOUT_ARTIST_MATCH: 0.8,

  /**
   * Intra-album similarity threshold for detecting variants
   * Higher threshold since we're comparing tracks in the same album
   * Used after stripping variant suffixes (Live, Acoustic, etc.)
   */
  INTRA_ALBUM_VARIANT: 0.85,
} as const;

/**
 * Helper to get the appropriate title threshold based on artist match
 */
export function getTitleThreshold(hasArtistMatch: boolean): number {
  return hasArtistMatch
    ? SIMILARITY_THRESHOLDS.TITLE_WITH_ARTIST_MATCH
    : SIMILARITY_THRESHOLDS.TITLE_WITHOUT_ARTIST_MATCH;
}
